import { IState } from 'shared/store';

export const selectBestPlaceReportBaseUrl = (state: IState) => state.rs.bestPlaceReportBaseUrl;
